import React from 'react';

export default function ModeSelect({ text, onSelect, onBack }) {
  if (!text) return null;

  const firstPara = text.paragraphs?.[0]?.join('') ?? '';
  const paraCount = text.paragraphs?.length ?? 1;

  return (
    <div className="mode-screen screen">

      {/* ─── ヘッダー ─── */}
      <div className="mode-screen-header" style={{ margin: '-20px -16px 0', width: 'calc(100% + 32px)' }}>
        <div className="v9-blob1" style={{ position: 'absolute', width: 140, height: 140, background: 'rgba(255,255,255,0.07)', borderRadius: '50%', top: -40, right: -30, pointerEvents: 'none' }} />
        <div className="v9-blob2" style={{ position: 'absolute', width: 80, height: 80, background: 'rgba(255,255,255,0.05)', borderRadius: '50%', bottom: -10, left: 20, pointerEvents: 'none' }} />
        <div className="mode-screen-header-inner">
          <button
            className="btn-back"
            style={{ border: '1px solid rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.8)', marginBottom: 0 }}
            onClick={onBack}
          >← もどる</button>
          <div className="mode-screen-title">どちらで　よむ？</div>
          <div style={{ width: 72 }} />
        </div>
      </div>

      {/* ─── テキストカード ─── */}
      <div className="v9-text-card">
        <div className="v9-text-meta">
          <div className="v9-text-book-badge">『{text.title}』</div>
          <div className="v9-text-para-badge">{paraCount}だんらく</div>
        </div>
        <div className="v9-text-body">{firstPara}</div>
        <div className="v9-text-footer">
          <div className="v9-text-footer-info">
            📖 {text.author || 'オリジナル'}
          </div>
        </div>
      </div>

      {/* ─── モードボタン ─── */}
      <div className="v9-action-btns">
        <button className="v9-action-btn v9-btn-practice" onClick={() => onSelect('renshyu', text)}>
          <div className="v9-btn-icon">📖</div>
          <div className="v9-btn-title">れんしゅう</div>
          <div className="v9-btn-sub">だんらくずつ</div>
        </button>
        <button className="v9-action-btn v9-btn-real" onClick={() => onSelect('honban', text)}>
          <div className="v9-btn-icon">🎯</div>
          <div className="v9-btn-title">ほんばん</div>
          <div className="v9-btn-sub">とおしてよむ</div>
        </button>
      </div>

    </div>
  );
}
